export default __webpack_public_path__ + "locales/sk/DeleteThirdPartyDialog.json?hash=944fabc7cb538d08ac64e93d05e18620";